import { useEffect, useMemo } from "react";
import { projectIdState } from "atoms/atoms-admin";
import { selectedInstanceState } from "atoms/atoms-content";
import { useRecoilValue, useRecoilState } from "recoil";
import CustomTable from "components/elements/CustomTableDivStyled";
import { BrmMainTable } from "brm/tables/BrmTables";
import PropTypes from "prop-types";
import useRefreshTableList from "hooks/useRefreshTableList";
import { TYPE } from "constants/brm";
import * as TrevApi from "brm/risk-model/trev/api";
import { ErrorBanner, LoadingSpinner as Loading } from "components/elements";
import { createColumnCategoryName } from "brm/tables/services/column/columnFactory";
import { useRoles } from "features/brm";

const ThreatEventCategoryTable = ({ setSelectedRows, refresh, setRefresh }) => {
  const { isRiskAnalyst } = useRoles();
  const projectId = useRecoilValue(projectIdState);
  const [selectedInstance, setSelectedInstance] = useRecoilState(selectedInstanceState);
  const { data: trevCats, isError } = TrevApi.useGetThreatEventCategories(projectId, {
    enabled: !!projectId && isRiskAnalyst,
  });

  const columns = useMemo(
    () => [createColumnCategoryName(selectedInstance.id, setSelectedInstance, "threatEventCategory")],
    [selectedInstance.id, setSelectedInstance]
  );

  // Refresh the table list if project selection changes
  useRefreshTableList(projectId, setRefresh);

  useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [refresh, setRefresh]);

  if (isError) {
    return <ErrorBanner msg="Error loading Threat Event Category data" />;
  }

  if (trevCats) {
    return (
      <>
        <CustomTable>
          <BrmMainTable
            data={trevCats}
            columns={columns}
            setSelectedRows={setSelectedRows}
            customProps={{ id: "ThreatEventCategoryTable_table" }}
            showRowSelect={false}
            elementName={TYPE.trevCat}
          />
        </CustomTable>
      </>
    );
  }
  return <Loading />;
};

ThreatEventCategoryTable.propTypes = {
  setSelectedRows: PropTypes.func.isRequired,
  refresh: PropTypes.bool.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default ThreatEventCategoryTable;
